import * as $ from 'jquery';
import { Chart } from 'chart.js';
import { ChartBase } from "./ChartBase";
import ChartDataLabels from 'chartjs-plugin-datalabels';

export class CreditRatingGauge extends ChartBase {
    private ratings : Map<string, number>;
    private currentRating : string;

    constructor(private container: JQuery) {
        super(container);
        var canvas = container.find('canvas')[0];
        this.currentRating = container.attr('data-credit-rating');
        
        this.canvasId = canvas.id;
        Chart.pluginService.register(ChartDataLabels);
        
        this.ratings = new Map();
        this.ratings.set('-', 0.5);
        this.ratings.set('AN', 1);
        this.ratings.set('C', 2);
        this.ratings.set('B', 3);
        this.ratings.set('A', 4);
        this.ratings.set('AA', 5);
        this.ratings.set('AAA', 6);

        // Get the score value of the current rating
        var score = this.ratings.get(this.currentRating)+.5;
        if(this.currentRating === 'INGEN-RAT') {
            score = 0.25;
        }

        this.configuration = $.extend(true, {}, this.configuration, {
            type: 'gauge',
            data: {
                labels: Array.from(this.ratings.keys()),
                datasets: [{
                    data: Array.from(this.ratings.values()),
                    value: score,
                    backgroundColor: ['#ED2028', '#FF4D0D', '#FFA220', '#FFB95F', '#EFE96F', '#A1CC47', '#7CC200'],
                    borderWidth: 2
                }]
            },
            options: {
                responsive: true,
                needle: {
                    radiusPercentage: 1.5,
                    widthPercentage: 3.2,
                    lengthPercentage: 6,
                    color: 'rgb(33, 37, 41,1)'
                },
                valueLabel: {
                    display: false
                },
                plugins: {
                    datalabels: {
                        display: true,
                        color: 'rgba(255, 255, 255, 0.8)',
                        backgroundColor: null,
                        font: {
                            size: 14,
                            weight: 'bold'
                        },
                        formatter: function (value, context) {
                            return context.chart.data.labels[context.dataIndex];
                        },
                    }
                },
                scales: this.configurationHideXY()
            }
        });

        this.initialize();
    }

    private initialize() {
        this.drawChart();
    }
}